import GetAllProducts from '@/services/logistics/ProductsService/GetAllProducts';

export default class ProductsService {
    getAllProducts() {
        return (new GetAllProducts()).handle();
    }
}
